import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class VendasPedidoService  extends ServerService {
  obtenhaResumo(filtro: any){
    return this.obtenha('/vendas/resumo', filtro);
  }

  obtenhaResumoComandas(filtro: any){
    return this.obtenha('/vendas/resumoComandas', filtro);
  }

  obtenhaResumoGarcons(filtro: any){
    return this.obtenha('/vendas/resumoComandas/garcons', filtro);
  }

  obtenhaResumoGarconsVendas(filtro: any){
    return this.obtenha('/vendas/resumo/garcons', filtro);
  }

  obtenhaResumoOperadoresVendas(filtro: any){
    return this.obtenha('/vendas/resumo/operadores', filtro);
  }


  obtenhaResumoPrudutos(filtro: any){
    return this.obtenha('/vendas/resumo/produtos', filtro);
  }

  obtenhaResumoProdutosQueVendemJuntos(filtro: any){
    return this.obtenha('/vendas/resumo/produtos/vendem-juntos', filtro);
  }

  obtenhaPedidosProdutosQueVendemJuntos(filtro: any){
    return this.obtenha('/vendas/resumo/produtos/vendem-juntos/pedidos', filtro);
  }

  obtenhaResumoAdicionais(filtro: any){
    return this.obtenha('/vendas/resumo/adicionais', filtro);
  }


  obtenhaResumoCupons(filtro: any){
    return this.obtenha('/vendas/resumo/cupons', filtro);
  }

  obtenhaResumoAdicionaisPruduto(idProduto: any, filtro: any = {}) {
    filtro.pid = idProduto;
    return this.obtenha('/vendas/resumo/produtos/adicionais', filtro);
  }

  obtenhaResumoAdicionaisCombinacoesProduto(idProduto: any, filtro: any = {}) {
    filtro.pid = idProduto;
    return this.obtenha('/vendas/resumo/produtos/adicionais/combinacoes', filtro);
  }

  obtenhaResumoAdicionaisCombinacoes(filtro: any = {}) {
    return this.obtenha('/vendas/resumo/produtos/adicionais/combinacoes', filtro);
  }
}
